$(document).ready(function () {
    $('.prechoice input').on('click', function () {


        var checkBoxClient = $('.prechoice #client');
        var checkBoxProspect = $('.prechoice #prospect');


        if (checkBoxClient.is(':checked') || checkBoxProspect.is(':checked')) {
            $(".form-account-creation").addClass('active');
            $(".woocommerce-form-row.btn.blue").addClass('active');
            $('.field-first-choice-box').addClass('active');


            if (checkBoxClient.is(':checked')) {
                $('.form-account-creation .code-client').addClass('active')
                $('.form-account-creation .tva').removeClass('active')

            } else if (checkBoxProspect.is(':checked')) {
                $('.form-account-creation .tva').addClass('active')
                $('.form-account-creation .code-client').removeClass('active')
            }
        }
    });

    function verifPhone(inputTarget) {

        if (inputTarget.length >= 1) {
            if (/^(b\+33|0|0033)[1-9]\d{8}$/.test(inputTarget.val())) {
                check_phone = true
            } else {
                check_phone = false
            }
        } else {
            check_phone = true
        }
        return check_phone;
    }

    function verifEmail(inputTarget) {

        if (inputTarget.length >= 1) {

            if (/^[\w-.]+@([\w-]+.)+[\w-]{2,4}$/.test(inputTarget.val())) {
                check_email = true
            } else {
                check_email = false
            }
        } else {
            check_email = true
        }
        return check_email;
    }


    $('.mm_account_request').on('click', function () {
        if (verifPhone($('input[name="telephone"]')) && verifEmail($('input[name="email"]'))) {

            if ($('input[name="newsletter"]').is(':checked')) {
                $newletter = 'oui';
            } else {
                $newletter = 'non';
            }

            if ($('.prechoice #client').is(':checked')) {
                var clientType = "Deja client";

            } else if ($('.prechoice #prospect').is(':checked')) {
                var clientType = "prospect";
            }
            let formData = new FormData();
            formData.append("client_type", clientType);
            formData.append("numero_siret", $('input[name="siret"]').val());
            formData.append("raison_sociale", $('input[name="raison-sociale"]').val());
            formData.append("code_postal", $('input[name="code-postal"]').val());
            formData.append("personne_contacter", $('input[name="personne-contacter"]').val());
            formData.append("telephone", $('input[name="telephone"]').val());
            formData.append("email", $('input[name="email"]').val());
            formData.append("interessed_by", $('select[name="interessed-by"]').val());
            formData.append("newsletter", $newletter); //checked = true

            $.ajax({
                url: mm_apiurl.request_account,
                type: "post",
                data: formData,
                contentType: false,
                processData: false,
                async: false,
                dataType: "json",
                success: function (d) {
                    let json = JSON.parse(d);
                },
            });

        } else {
            // console.log($('.confirmation .icn-text .text'));
            // $('.confirmation .icn-text .text').replaceWith("<div class='text wrong'>Votre demande d'ouverture de compte n\'a pas été prise en compte en raison d'une erreur de saisie");
            // setTimeout(() => {
            //     $('.confirmation').removeClass('shown');
            //     $('.addresses').addClass('shown');
            //     $('.confirmation .icn-text .text').replaceWith("<div class='text'>Votre demande d'ouverture de compte a été transmise à notre équipe commerciale. Un conseiller va vous recontacter dans les meilleurs délais.</div>");
            // }, 2000);

        }

    });
});